var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareRoundBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16157",
    "data-name": "Rectangle 16157",
    width: 11.872,
    height: 13.24,
    fill: "#313131"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15452",
    "data-name": "Group 15452",
    transform: "translate(0 0.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_628",
    "data-name": "Ellipse 628",
    transform: "translate(0 -0.182)",
    fill: "none",
    stroke: "#313131",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15455",
    "data-name": "Group 15455",
    transform: "translate(6 6.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15452-2",
    "data-name": "Group 15452",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41215",
    "data-name": "Path 41215",
    d: "M9.626,13.24c-.121-.02-.244-.033-.364-.06a2.131,2.131,0,0,1-1.591-2.622.063.063,0,0,0-.034-.088q-1.991-1.148-3.981-2.3l-.032-.017a2.139,2.139,0,1,1,.073-3l.761-.439q1.6-.924,3.2-1.846a.073.073,0,0,0,.04-.1A2.136,2.136,0,0,1,9.363.034C9.436.02,9.509.011,9.582,0h.312c.073.011.146.02.218.034A2.137,2.137,0,1,1,8.149,3.567a.288.288,0,0,0-.029.013L4.19,5.848c-.041.024-.046.044-.031.088a2.056,2.056,0,0,1,.079,1.045c-.03.159-.079.314-.121.476l3.965,2.29L8.125,9.7a2.1,2.1,0,0,1,1.909-.715,2.135,2.135,0,0,1,.236,4.182c-.138.034-.281.05-.421.074Z",
    transform: "translate(0)",
    fill: "#313131"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareRoundBorder);
export default __webpack_public_path__ + "static/media/share-round-border.0df3901dd54d4557a077bb68e64ee2b9.svg";
export { ForwardRef as ReactComponent };